<ng2-smart-table (createConfirm)="onCreate($event)" (custom)="customButton($event)" (deleteConfirm)="deleteConfirm($event)"
                 (editConfirm)="onEdit($event)"
                 (rowSelect)="rowSelect($event)" *ngIf="isCore && settings"
                 [settings]="settings" [source]="data"></ng2-smart-table>

<div *ngIf="!isCore">
    <ion-card (click)="rowSelect(item)" *ngFor="let item of data.filteredAndSorted" [ngClass]="{'active':item.active}">
        <ion-card-header class="contentHeader">
            <ion-grid>
                <ion-row>
                    <ion-col>Pos.:{{item.sort}}</ion-col>
                    <ion-col>{{item.type}}</ion-col>
                    <ion-col>{{item.firstname}}</ion-col>
                    <ion-col>{{item.lastname}}</ion-col>
                </ion-row>
            </ion-grid>
        </ion-card-header>
        <ion-card-content>
            {{'Company' | translate}}: {{item.company}}<br/>
            {{'Street' | translate}}: {{item.street}}<br/>
            {{'City' | translate}}: {{item.zip}} {{item.city}}<br/>
        </ion-card-content>
    </ion-card>
</div>
